import topBanner from '/images/top_banner.webp'
import { Box } from '@chakra-ui/react/box'
import { Stack } from '@chakra-ui/react/stack'
import { Text } from '@chakra-ui/react/text'
import { isSupportedBrowser } from '@el5/native-api'

import Button from '@/components/Button'
import { Container } from '@/components/Container'
import { Header } from '@/pages/Esum/components/Header'
import { ButtonVariant } from '@/types/enum'

import { Carousel, type CarouselItem } from './components/Carousel'
import classes from './styles.module.css'

export interface EsumOfferViewProps {
  buttonText: string
  buttonVariant: ButtonVariant
  buttonHref: string
  accentColor: string
  carouselItems: CarouselItem[]
  deeplink: string
}

export function EsumOfferView({
  buttonText,
  buttonVariant,
  buttonHref,
  accentColor,
  carouselItems,
}: EsumOfferViewProps) {
  return (
    <Box className={classes.page}>
      <Header hideBackButton={!isSupportedBrowser()} />

      <Container className={classes.mainContainer}>
        <Box className={classes.card}>
          <img src={topBanner} alt="" className={classes.banner} />
          <Stack className={classes.cardBody}>
            <Text className={classes.title}>Поймайте свою выгоду</Text>
            <Box className={classes.offerText}>
              <Text className={classes.offerTextInner}>
                Выполняйте задания
                <br />и получайте в награду баллы
                <br />
                «X5 Клуба»
              </Text>
            </Box>
          </Stack>
        </Box>

        <Box className={classes.card}>
          <Stack className={classes.cardBody}>
            <Text className={classes.title}>Установите приложение</Text>
            <Button
              variant={buttonVariant}
              onClick={() => window.open(buttonHref, '_blank')}
            >
              {buttonText}
            </Button>
          </Stack>
        </Box>

        <Box className={classes.card}>
          <Stack className={classes.cardBody}>
            <Text className={classes.mechanicTitle}>Как участвовать?</Text>
            <Carousel items={carouselItems} accentColor={accentColor} />
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}
